module.exports = __webpack_public_path__ + "img/treeSapling.10d836aa.svg";